import { Injectable } from "@angular/core";
import { PoComboOption, PoNotificationService } from "@po-ui/ng-components";
import { LocalStorageType } from "../types/localStorage.type";
import { HttpClient } from "@angular/common/http";
import { PaginationResponseModel } from "../models/responses/pagination.response.model";
import { BranchResponseModel } from "../models/responses/branch.response.modal";
import { environment } from "../environments/environment";
import { firstValueFrom } from "rxjs";
import { CatchHandler } from "../utils/catchHandler.util";
import { GlobalService } from "./global.service";

@Injectable({
    providedIn: 'root'
})
export class CompanyDataService {
    constructor(
        private http: HttpClient,
        private catchHandler: CatchHandler,
        private poNotification: PoNotificationService,
        private globalService: GlobalService
    ) {

    }

    private branchesEndpoint: string = 'api/totvsmoda/internal/management/v2/branches';

    get apiHost(): string {
        return this.globalService.getClientHost() || environment.API_URL;
    }

    public async getBranches(): Promise<Array<any> | null> {
        const storageBranches = localStorage.getItem(LocalStorageType.Branches);

        if (storageBranches !== null)
            return this.getBranchesFromSessionStorage(storageBranches);

        return this.getNewBranches();
    }

    private async getNewBranches(): Promise<Array<any> | null> {
        const branches: Array<any> = [];

        const request = this.http.get<PaginationResponseModel<BranchResponseModel>>(
            this.apiHost + this.branchesEndpoint
        );

        const isRequestOk = await firstValueFrom(request)
            .then((res) => {
                res.items.forEach((branch: BranchResponseModel) => {
                    branches.push({
                        [branch.branchCode]: {
                            branchCode: branch.branchCode,
                            fantasyName: branch.fantasyName,
                            cnpj: branch.cnpj
                        }
                    });
                });

                const stringfiedBranches = JSON.stringify(branches!);

                localStorage.setItem('branches', stringfiedBranches);

                return true;
            })
            .catch((err) => {
                const errors = this.catchHandler.handle(err);

                if (errors.length === 0) {
                    return false;
                }

                errors.forEach((error) => {
                    this.poNotification.warning(error.message);
                });

                return false;
            });

        if (!isRequestOk)
            return null;

        if (branches.length === 0) {
            this.poNotification.warning("Não há empresas liberadas para este usuário.");
            return null;
        }
        return new Promise<Array<any>>((resolve) => { resolve(branches); });
    }

    private async getBranchesFromSessionStorage(sessionStorageBranches: string): Promise<Array<any>> {
        const branches = JSON.parse(sessionStorageBranches!);

        return new Promise<Array<any>>((resolve) => { resolve(branches); });
    }
}